import Dexie from 'dexie';

export const pathologyDb = new Dexie('mukti-pathology-db');

pathologyDb.version(1).stores({
  refCache: 'key',
  outbox: '++id, clientId, status, createdAt',
  localBills: 'clientId, createdAt',
});

pathologyDb.version(2).stores({
  nicuOutbox: 'clientId, type, status, createdAt',
  nicuLocal: 'clientId, type, createdAt',
});

export default pathologyDb;